import React, { useCallback } from 'react';
import InputField, { InputFieldProps } from '../InputField';
import s from './LimitedTextInputField.scss';

export interface Props extends Omit<InputFieldProps, 'postfix' | 'type'> {
  // Required because we can't calculate the remaining character count without it
  value: string;

  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  maxLength: number;
}

/** One of our standard `<input type="text" />`s.
 *
 * Limits input to a specified length (`max`) and displays the remaining character allowance to the right of the inner input.
 */
const LimitedTextInputField = React.forwardRef<HTMLInputElement, Props>(
  ({ maxLength, value, onChange, ...rest }, ref) => {
    const handleOnChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length > maxLength) {
          return;
        }
        onChange && onChange(e);
      },
      [onChange, maxLength]
    );

    return (
      <InputField
        type="text"
        maxLength={maxLength}
        value={value}
        onChange={handleOnChange}
        postfix={
          <span className={s['postfix']}>
            {maxLength - (0 | value?.length)}</span>
        }
        {...rest}
        ref={ref}
      />
    );
  }
);

export default LimitedTextInputField;
